import React, { useState, useEffect } from 'react';
import Axios from "axios";
import { Grid, Typography, CircularProgress, Container, Box, Button } from "@mui/material";
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CardComponent from '../Piac/PiacComponents/CardComponent';

function AllAccommodationListings() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const { config, environment } = require('../../index');

  const queryParams = new URLSearchParams(location.search);
  const accType = queryParams.get('type');

  useEffect(() => {
    const source = Axios.CancelToken.source();
    async function fetchListings() {
      try {
        let endpoint = config[environment].marketplaceAccommodationEndpoint;
        if (accType) {
          endpoint += `?type=${accType}`;
        }
        const response = await Axios.get(endpoint, { cancelToken: source.token });
        
        // Add key: 'MarketplaceAccommodation' to fetched listings for IconDisplay logic later if needed
        const processedListings = response.data.map(l => ({ 
          ...l, 
          key: 'MarketplaceAccommodation',
          // Adapt MarketplaceAccommodation fields to CardComponent expected fields if different
          price: l.price_per_night,
          rental_frequency: l.price_type === 'Person' ? t('Accommodation.PricePerNightPersonShort', 'fő/éj') : t('Accommodation.PricePerNightRoomShort', 'szoba/éj'),
          listing_type: t(`SubMenu.${l.accommodation_type}`),
          property_status: 'Rent', // Usually accommodations are for rent
          isMarketplace: true // Custom flag to identify MarketplaceAccommodation
        }));
        
        setListings(processedListings);
        setLoading(false);
      } catch (error) {
        if (!Axios.isCancel(error)) {
          console.error("Error fetching accommodation listings:", error);
          setLoading(false);
        }
      }
    }
    fetchListings();
    return () => source.cancel();
  }, [accType, config, environment]);

  if (loading) {
    return (
      <Grid container justifyContent="center" alignItems="center" sx={{ height: "100vh" }}>
        <CircularProgress />
      </Grid>
    );
  }

  const getTitle = () => {
    if (!accType) return t('Header.Szallas');
    return t(`SubMenu.${accType}`);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4, mt: '50px' }}>
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
        <Typography variant="h4" sx={{ color: 'var(--sznodarkblue)', fontWeight: 'bold' }}>
          {getTitle()}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Button variant="contained" onClick={() => navigate(`/${i18n.language}/addaccommodation`)} sx={{ bgcolor: '#2492be' }}>
              {t('Accommodation.RegisterAsProvider', 'Jelentkezés szállásadóként')}
            </Button>
            <Button variant="outlined" onClick={() => navigate(`/${i18n.language}/accommodation-market`)}>
            {t('Common.Back')}
            </Button>
            <Button variant="contained" onClick={() => navigate(`/${i18n.language}/terkep`)}>
            {t('Map.ViewOnMap')}
            </Button>
        </Box>
      </Box>
      <Grid container spacing={3}>
        {listings.length === 0 ? (
          <Typography variant="h6" sx={{ mt: 4, width: '100%', textAlign: 'center' }}>
            {t('Market.NoListings', 'Currently no listings available.')}
          </Typography>
        ) : (
          listings.map((listing) => (
            <Grid item xs={12} sm={6} md={4} key={listing.id}>
              <CardComponent 
                listing={listing} 
                state={{ mapInstance: null }} 
                setFlyToLocation={() => {}} 
                navigate={navigate} 
              />
            </Grid>
          ))
        )}
      </Grid>
    </Container>
  );
}

export default AllAccommodationListings;
